import React, { useReducer } from "react";
import { AllImages } from "../../Assets/Images/AllImages";
import "./ContactMe.scss";
import user from "../../Common/JsonFiles/simran.json";
const ContactMe = () => {
  return (
    <div className="w-100 contact-main-container">
      <div class="row">
        {/* <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4 d-flex a-i-c f-d-c">
          <p className="d-flex a-i-c m-0">
            <i className="img-contact fa fa-phone"></i> Call Me{" "}
          </p>
          <p>+91 {user.mobile}</p>
        </div> */}
        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 d-flex a-i-c f-d-c">
          <p className="d-flex a-i-c m-0">
            <i className="img-contact fa fa-envelope-open"></i> Email{" "}
          </p>
          <p>{user.email}</p>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 d-flex a-i-c f-d-c">
          <p className="d-flex a-i-c m-0">
            <i className="img-contact fa fa-map-marker"></i> Location{" "}
          </p>
          <p> {user.location}</p>
        </div>
      </div>
    </div>
  );
};

export default ContactMe;
